<template>
  <!-- Button trigger modal -->
  <div class="c-base general-disclaimer"><a type="button" @click="toggleModal" class="" style="text-decoration:underline" data-bs-toggle="modal" data-bs-target="#generalDisclaimer">
      General Disclaimer
  </a></div>

  <!-- Modal -->
  <div v-show="isModalVisible" @click.self="toggleModal" class="modal fade show" style="display: block !important" id="generalDisclaimer" data-bs-backdrop="static" data-bs-keyboard="false" tabindex="-1" role="dialog" aria-labelledby="generalDisclaimerTitle" aria-hidden="true">
      <div class="modal-dialog modal-dialog-centered modal-lg" role="document">
          <div class="modal-content">
          <div class="modal-header">
              <h5 class="modal-title fs-5" id="generalDisclaimerTitle">General Disclaimer</h5>
              <button type="button" @click="toggleModal" class="btn-close" data-dismiss="modal" aria-label="Close">
              </button>
          </div>
          <div class="modal-body">
              "You understand and acknowledge that the tools and resources accessed on the OysterHR.com website, the Oyster Platform, Oyster Academy, and all other sites owned or operated by Oyster HR, Inc. (collectively, the “Site”) are provided as-is. These tools and resources are provided for general information only and are not intended to amount to advice on which You should or can rely. You must obtain professional or specialist advice before taking, or refraining from taking, any action on the basis of the content on Our Site.  Although we make reasonable efforts to update the information on our Site, we make no representations, warranties, or guarantees, whether express or implied, that the content on Our Site is accurate, complete, or up-to-date."
          </div>
          <div class="modal-footer">
              <button type="button" @click="toggleModal" class="btn btn-secondary" data-dismiss="modal">Close</button>
          </div>
          </div>
      </div>
  </div>
</template>

<script>
import { ref } from 'vue'
export default {
  setup(props) {
    const isModalVisible = ref(false)
    async function toggleModal(){
      isModalVisible.value = !isModalVisible.value
    }
    return {
      toggleModal,
      isModalVisible
    }
  },
}
</script>